import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import TextCopy from 'components/atoms/TextCopy'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

import { formatDate, LOCAL_DATE_FORMAT } from 'utils/date'

const styles = theme => ({
  root: {
    height: 95,
    display: 'flex',
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F5F7FA',
    padding: `0 ${theme.spacing(4)}px`,
  },
  loader: {
    color: theme.palette.white,
  },
  label: {
    fontSize: 16,
    marginTop: theme.spacing(1),
  },
  boldLabel: {
    fontWeight: 700,
  },
  deActivate: {
    cursor: 'pointer',
  },
  empty: {
    color: theme.palette.text.disabled,
  },
})

const hasCode = (data) => {
  return !!(data && data.code)
}

const OrganisationCode = ({
  data,
  classes,
  onCodeCopy,
  onGenerateClick,
  onDeactivateClick,
}) => (
  <div className={classes.root}>
    <Grid
      container
      className={classes.content}
      direction="row"
      wrap="nowrap"
      alignItems="center"
      justify="space-between">
      <Grid direction="row" container>
        {hasCode(data) ? (
          <Fragment>
            <Grid item md={6}>
              <Typography>Active project code</Typography>
              <TextCopy
                className={classNames(classes.label, classes.boldLabel)}
                text={data.code}
                onCopy={onCodeCopy}
              />
            </Grid>
            <Grid item md={6}>
              <Typography>Code expiry</Typography>
              <Typography className={classes.label}>
                {data.expireDate
                  ? formatDate(data.expireDate, LOCAL_DATE_FORMAT)
                  : 'Never'}
              </Typography>
            </Grid>
          </Fragment>
        ) : (
          <Grid item lg={12}>
            <Typography className={classes.empty}>
                  You currently don't have an active project code to share
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid direction="row" container alignItems="center">
        <Grid item md={5}>
          {hasCode(data) && (
            <Typography
              onClick={onDeactivateClick}
              className={classNames(classes.deActivate, classes.empty)}>
                Deactivate code
            </Typography>
          )}
        </Grid>
        <Grid container item md={7} justify="flex-end">
          <SubmitButton
            size="medium"
            type="submit"
            color="primary"
            loading={false}
            variant="primary"
            disabled={hasCode(data)}
            onClick={onGenerateClick}>
              Generate project code
          </SubmitButton>
        </Grid>
      </Grid>
    </Grid>
  </div>
)

OrganisationCode.propTypes = {
  data: PropTypes.shape({
    code: PropTypes.string,
    expireDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
  }),
  classes: PropTypes.object,
  onCodeCopy: PropTypes.func,
  dataLoaded: PropTypes.bool,
  onGenerateClick: PropTypes.func,
  onDeactivateClick: PropTypes.func,
}

export default withStyles(styles)(OrganisationCode)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleOverview/OrganisationCode.js